"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
var home_page_anti_phishing_icon_svg_1 = __importDefault(require("@assets/components/home/feature-list-sliver/home-page-anti-phishing-icon.svg"));
var home_page_customised_icon_svg_1 = __importDefault(require("@assets/components/home/feature-list-sliver/home-page-customised-icon.svg"));
var home_page_analytics_icon_svg_1 = __importDefault(require("@assets/components/home/feature-list-sliver/home-page-analytics-icon.svg"));
var home_page_file_sharing_icon_svg_1 = __importDefault(require("@assets/components/home/feature-list-sliver/home-page-file-sharing-icon.svg"));
var q_tag_01_svg_1 = __importDefault(require("@assets/components/home/feature-list-sliver/q-tag-01.svg"));
var q_tag_02_svg_1 = __importDefault(require("@assets/components/home/feature-list-sliver/q-tag-02.svg"));
var format_1 = require("../../app/util/format");
var constants_1 = require("../../../shared/constants");
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c, _d, _e;
    return core_1.createStyles({
        grid: (_a = {},
            _a[theme.breakpoints.up('lg')] = {
                marginTop: theme.spacing(4),
            },
            _a.margin = '0 auto',
            _a.width = '100%',
            _a.maxWidth = '1200px',
            _a.justifyContent = 'center',
            _a.alignItems = 'center',
            _a.textAlign = 'center',
            _a),
        columnGrid: (_b = {
                maxWidth: 'min(600px, calc(100% + 48px))'
            },
            _b[theme.breakpoints.up('lg')] = {
                maxWidth: '502px',
            },
            _b[theme.breakpoints.up('xl')] = {
                maxWidth: '574px',
            },
            _b.justifyContent = 'center',
            _b.alignItems = 'center',
            _b),
        card: (_c = {
                boxShadow: 'none',
                height: '335px',
                backgroundColor: constants_1.THEME_COLOR.PRIMARY,
                alignItems: 'flex-start',
                flexDirection: 'row',
                border: '1px solid #394B53',
                borderRadius: '30px',
                padding: '20px'
            },
            _c[theme.breakpoints.up('md')] = {
                width: '484px',
            },
            _c[theme.breakpoints.down('md')] = {
                height: 'auto',
            },
            _c),
        cardVectorIcon: (_d = {
                minWidth: '50px',
                textAlign: 'center'
            },
            _d[theme.breakpoints.up('lg')] = {
                minWidth: '50px',
                minHeight: '20px',
            },
            _d),
        cardContent: {
            paddingTop: theme.spacing(1),
            paddingLeft: theme.spacing(0),
            paddingRight: theme.spacing(0),
            '&:last-child': {
                paddingBottom: 0,
            },
        },
        descText: (_e = {
                textAlign: 'center'
            },
            _e[theme.breakpoints.down('xs')] = {
                width: '70%',
            },
            _e),
        qTag01: {
            maxHeight: 20,
            marginRight: 20,
        },
        qTag02: {
            maxHeight: 20,
            marginLeft: 10,
            alignSelf: 'end',
        },
    });
});
var FeatureListSliver = function () {
    var t = react_i18next_1.useTranslation().t;
    var classes = useStyles();
    var theme = core_1.useTheme();
    var isDesktopWidth = core_1.useMediaQuery(theme.breakpoints.up('lg'));
    var columns = [
        {
            id: 1,
            data: [
                {
                    icon: home_page_anti_phishing_icon_svg_1.default,
                    title: t('homePage.features.antiPhishing.title'),
                    description: t('homePage.features.antiPhishing.description'),
                },
                {
                    icon: home_page_file_sharing_icon_svg_1.default,
                    title: t('homePage.features.fileSharing.title'),
                    description: t('homePage.features.fileSharing.description'),
                },
            ],
        },
        {
            id: 2,
            data: [
                {
                    icon: home_page_customised_icon_svg_1.default,
                    title: t('homePage.features.customised.title'),
                    description: t('homePage.features.customised.description'),
                },
                {
                    icon: home_page_analytics_icon_svg_1.default,
                    title: t('homePage.features.analytics.title'),
                    description: t('homePage.features.analytics.description'),
                },
            ],
        },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Grid, { container: true, direction: "row", justifyContent: "center", alignItems: "flex-start" },
            react_1.default.createElement("img", { src: q_tag_01_svg_1.default, alt: "quote tag", className: classes.qTag01 }),
            react_1.default.createElement("div", { className: classes.descText },
                react_1.default.createElement(core_1.Typography, { variant: "h3", color: "textPrimary", display: "inline", gutterBottom: true, style: { fontWeight: 700 } },
                    t('general.forOfficer'),
                    ' '),
                react_1.default.createElement("br", null),
                react_1.default.createElement(core_1.Typography, { variant: "body1", color: "textPrimary", display: "inline", gutterBottom: true, dangerouslySetInnerHTML: {
                        __html: format_1.htmlSanitizer(t('homePage.targetUsersPhrase')),
                    }, style: { color: '#F6BE2C', fontWeight: 700 } })),
            react_1.default.createElement("img", { src: q_tag_02_svg_1.default, alt: "quote tag", className: classes.qTag02 })),
        react_1.default.createElement(core_1.Grid, { container: true, className: classes.grid, spacing: 6, direction: !isDesktopWidth ? 'column' : 'row' }, columns.map(function (column) { return (react_1.default.createElement(core_1.Grid, { key: column.id, item: true, container: true, spacing: 6, direction: "column", className: classes.columnGrid }, column.data.map(function (card) { return (react_1.default.createElement(core_1.Grid, { item: true, key: card.title },
            react_1.default.createElement(core_1.Card, { className: classes.card },
                react_1.default.createElement(core_1.Grid, { container: true, direction: "column", justifyContent: "center", alignItems: "center" },
                    react_1.default.createElement("img", { className: classes.cardVectorIcon, src: card.icon, alt: card.title }),
                    react_1.default.createElement(core_1.Typography, { variant: "subtitle1", gutterBottom: true, style: { color: 'white' } },
                        react_1.default.createElement("strong", null, card.title))),
                react_1.default.createElement(core_1.CardContent, { className: classes.cardContent },
                    react_1.default.createElement(core_1.Typography, { style: { color: 'white' } }, card.description))))); }))); }))));
};
exports.default = FeatureListSliver;
